import { render, staticRenderFns } from "./Reestr2.vue?vue&type=template&id=5147c537&"
import script from "./Reestr2.vue?vue&type=script&lang=js&"
export * from "./Reestr2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports